<template>
    <span>
        <h3>Kit List</h3>
        <ul class="list-group">
            <li class="list-group-item text-left" v-for="kitItem in kit">{{kitItem.pivot.units}} x {{kitItem.full_name}}</li>
        </ul>
    </span>
</template>
<script>
    export default {
        name: 'shop-kit-list',

        data() {
            return {

            }
        },

        props: [ 'kit', 'productSlug' ]
    }
</script>